<template>
	<!-- اپ فعال -->
	<router-link
		v-if="app.active"
		:to="`/app/${app.id}`"
		class="card active"
	>
		<img :src="require(`@/assets/images/${app.image}`)" alt="app" />
		<span class="link-text">مشاهده / دانلود</span>
	</router-link>

	<!-- اپ غیرفعال -->
	<router-link
		v-else
		:to="`/app/${app.id}`"
		class="card inactive"
	>
<!--		<img :src="require(`@/assets/images/${app.image}`)" alt="app" />-->
		<h3>{{ app.name }}</h3>
		<p>{{ app.subtitle }}</p>
	</router-link>
</template>

<script>
export default {
	name: 'AppCard',
	props: ['app']
}
</script>

<style lang="scss" scoped>
.card {
	background-color: #00D0C4;
	border-radius: 16px;
	padding: 2rem 1rem;
	width: 220px;
	text-align: center;
	transition: 0.3s ease;

	img {
		width: 78px;
		margin-bottom: 1rem;
	}

	h3 {
		font-size: 1.2rem;
		font-weight: bold;
		color: #000;
	}

	p {
		color: #333;
		font-size: 0.9rem;
	}

	.link-text {
		display: block;
		margin-top: 1rem;
		font-size: 0.8rem;
		color: #014e4b;
	}

	&.inactive {
		background-color: #3a3a3a;
		opacity: 0.5;
		color: #ccc;

		h3, p {
			color: #ccc;
		}
	}

	&:hover {
		transform: translateY(-4px);
	}
}
</style>